// extracted by mini-css-extract-plugin
export var logo = "_jg-2";
export var logoWrapper = "_jg-1";
export var strip = "_jg-0";